var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { XForm } from "@bluelibs/x-ui-admin";
import { Service, Inject } from "@bluelibs/core";
import { SmileOutlined } from "@ant-design/icons";
import * as Ant from "antd";
import { CompaniesCollection, BanksCollection, BankAccountsCollection, } from "@bundles/UIAppBundle/collections";
import { BankAccountCurrency } from "@bundles/UIAppBundle/collections/BankAccounts/enum";
let BankAccountEditForm = class BankAccountEditForm extends XForm {
    build() {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "accountNumber",
                label: t("management.bank_accounts.fields.accountNumber"),
                name: ["accountNumber"],
                required: true,
                component: Ant.Input,
            },
            {
                id: "currency",
                label: t("management.bank_accounts.fields.currency"),
                name: ["currency"],
                required: true,
                render: (props) => {
                    const options = Object.keys(BankAccountCurrency).map((currency) => ({
                        label: currency,
                        value: currency,
                    }));
                    return (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Select, Object.assign({ placeholder: t("management.bank_accounts.fields.currency") }, { children: options.map((option) => (_jsx(Ant.Select.Option, Object.assign({ value: option.value }, { children: option.label }), option.value))) }), void 0) }), void 0));
                },
            },
            {
                id: "initialBalance",
                label: t("management.bank_accounts.fields.initialBalance"),
                name: ["initialBalance"],
                required: true,
                component: Ant.InputNumber,
            },
            {
                id: "companyId",
                label: t("management.bank_accounts.fields.company"),
                name: ["companyId"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: CompaniesCollection, field: "name", required: true }, void 0) }), void 0)),
            },
            {
                id: "bankId",
                label: t("management.bank_accounts.fields.bank"),
                name: ["bankId"],
                required: true,
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: BanksCollection, field: "name", required: true }, void 0) }), void 0)),
            },
        ]);
    }
    static getRequestBody() {
        return {
            _id: 1,
            accountNumber: 1,
            currency: 1,
            initialBalance: 1,
            company: {
                _id: 1,
                name: 1,
            },
            companyId: 1,
            bank: {
                _id: 1,
                name: 1,
            },
            bankId: 1,
        };
    }
    onSubmit(_id, values) {
        const { t } = this.i18n;
        return this.collection
            .updateOne(_id, { $set: values })
            .then(({ _id }) => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.bank_accounts.edit_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
        })
            .catch((err) => {
            Ant.notification.warn({
                message: t("generics.error"),
                description: t("generics.error_message"),
            });
        });
    }
};
__decorate([
    Inject(() => BankAccountsCollection),
    __metadata("design:type", typeof (_a = typeof BankAccountsCollection !== "undefined" && BankAccountsCollection) === "function" ? _a : Object)
], BankAccountEditForm.prototype, "collection", void 0);
BankAccountEditForm = __decorate([
    Service({ transient: true })
], BankAccountEditForm);
export { BankAccountEditForm };
